import { useMemo }             from 'react';
import { connect }             from 'react-redux';
import { reducerType }         from 'reducer';
import Button                  from './Button';
import useButtonProps          from './useButtonProps';
import { colors }              from 'utils/colors';
import { modalStateType, teacherUrlStateType } from 'types';
import { sizeStateType }       from 'reducer/types';
import { makeStyles }           from 'makeStyles';


const useStyles = makeStyles()(() => ({
    buttonContainer: {
        width:           '100%',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'space-evenly',
    },
    button: {
        width:           175,
        height:          40,
        fontSize:        20,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        textAlign:       'center',
        backgroundColor: colors.primary,
        color:           '#FFF',
        fontWeight:      'bold',
        cursor:          'pointer',
        borderRadius:    '0.2em',
        boxShadow:       '2px 4px 9px rgba(0,0,0,0.1)',
        '&:hover': {
            opacity: 0.5
        }
    }
}))




type ButtonsType = {
    email:           string;
    name:            string;
    message:         string;
    lessonNumber:    string;
    modalState:      modalStateType;
    sizeState:       sizeStateType;
    teacherUrlState: teacherUrlStateType;
    setError:        (val: string) => void;
    closeModal:      () => void;
}

const Buttons: React.FC<ButtonsType> = ({
    sizeState,
    modalState,
    teacherUrlState,
    email,
    name,
    message,
    lessonNumber,
    setError,
    closeModal
}) => {

  const { classes } = useStyles();

  const variant = useMemo(() => { return modalState.modalVariant },[modalState])


  const buttonProps = useButtonProps(
    classes,
    variant,
    lessonNumber,
    email,
    name,
    message,
    teacherUrlState,
    setError,
    closeModal
  )

 
  const rootStyle = useMemo(() => {
    return {
      borderTop: sizeState.wideScreen && sizeState.longScreen ? '1px solid #DDD' : 'none',
      minHeight: sizeState.wideScreen && sizeState.longScreen ? 70 : 60,

    }
  },[sizeState])


  return (
    <div 
      className = { classes.buttonContainer }
      style     = { rootStyle }
    >
        {
          buttonProps.map((val, ind) => {
            return(
              <Button
                 key     = { `${ !!val['txt'] ? val['txt'] : '<Button<' }:${ ind }` }
                 props   = { val }
              />
            )
          })
        }
    </div>
  );
}






const mapStateToProps = (reducer: reducerType) => {

  return {
     sizeState:  reducer.size,
     modalState: reducer.modal
}};

export default connect(mapStateToProps)(Buttons);
